import styled from 'styled-components';

export default function AllSwitch({
  isOn,
  setIsOn,
}: {
  isOn: boolean;
  setIsOn: (value: boolean) => void;
}) {
  return (
    <SwitchButton isOn={isOn} onClick={() => setIsOn(!isOn)}>
      <span>{isOn ? 'ON' : 'OFF'}</span>
      <Circle isOn={isOn} />
    </SwitchButton>
  );
}

const SwitchButton = styled.button<{ isOn: boolean }>`
  width: 60px;
  height: 32px;
  border-radius: 999px;
  border: none;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: ${({ isOn }) => (isOn ? 'flex-end' : 'flex-start')};
  background-color: ${({ isOn }) => (isOn ? '#111' : '#ccc')};
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;

  span {
    z-index: 1;
    position: absolute;
    left: ${({ isOn }) => (isOn ? '8px' : 'auto')};
    right: ${({ isOn }) => (isOn ? 'auto' : '8px')};
    color: #fff;
  }
`;

const Circle = styled.div<{ isOn: boolean }>`
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  z-index: 2;
  transition: all 0.3s ease;
`;
